export var GeneralError;
(function (GeneralError) {
    GeneralError["fetchFailed"] = "fetch-failed";
})(GeneralError || (GeneralError = {}));
var Failure = /** @class */ (function () {
    function Failure(codes) {
        this.codes = codes;
    }
    Failure.prototype.has = function (error) {
        return this.codes.has(error);
    };
    Failure.prototype.hasAnyOf = function (errors) {
        var _this = this;
        return errors.findIndex(function (error) { return _this.has(error); }) >= 0;
    };
    Failure.prototype.hasNot = function (error) {
        return !this.has(error);
    };
    Failure.prototype.hasUnhandled = function (errors) {
        var handledSet = new Set(errors);
        return Array.from(this.codes).findIndex(function (error) { return !handledSet.has(error); }) >= 0;
    };
    Failure.prototype.some = function () {
        var _a;
        return (_a = Array.from(this.codes)[0]) !== null && _a !== void 0 ? _a : null;
    };
    return Failure;
}());
export { Failure };
